import React, { Component } from 'react';
import { connect } from 'react-redux';
import { history } from '../../../../store';
import DataTable from '../../../common/datatable';
import { dateFormat } from '../../../../utils/commonFunctions';

class PrizesList extends Component {
  render() {
    const columns = [
      {
        prop: 'user-id',
        title: 'User Id',
      },
      {
        prop: 'customer-number',
        title: 'Customer Number',
      },
      {
        prop: 'incentive-name',
        title: 'Incentive Name'
      },
      { prop: 'name',
        title: 'Prize Name'
      },
      {
        prop: 'award-date',
        title: 'Prize Award Date',
        format(data) {
          return dateFormat(data);
        }
      },
      { prop: 'value',
        title: 'Prize Value (€)'
      }
    ];

    const actions = [
      {
        label: 'Edit',
        color: 'grey',
        permissions: {
          action: 'manage',
          subjectClass: 'StaffRewardSetting'
        },
        callback: (row) => {
          history.push(`/admin/prizes/${row.id}`);
        }
      },
      {
        label: 'Delete',
        permissions: {
          action: 'manage',
          subjectClass: 'StaffRewardSetting'
        },
        callback: (row) => {
          this.props.onDelete(row.id);
        }
      }
    ];

    const { prizes, paging } = this.props;

    return (
      <div>
        <DataTable
          hideId
          data={prizes}
          columns={columns}
          actions={actions}
          dataSize={paging ? paging.number * paging.size : prizes.length}
          actionWidth="360"
          pagination={{
            page: this.props.currentPage,
            sizePerPage: 10,
            onPageChange: this.props.onPageChange
          }}
          remote
        />
      </div>
    );
  }
}

export default connect()(PrizesList);



// WEBPACK FOOTER //
// ./src/components/admin/prizes/list/prizes-list.js